import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, UserLogin } from 'ngx-sds-login';
import { Observable, Subject, combineLatest, takeUntil } from 'rxjs';
import { ParametersDTO } from 'src/app/infraestructure/interfaces/parameters/ParametersDTO';
import { GuardarVehiculoSubcontratadoDTO } from 'src/app/infraestructure/interfaces/referente/GuardarVehiculoSubcontratadoDTO';
import { CambiarEstadoVehiculoI } from 'src/app/infraestructure/models/cambiarEstadoVehiculo';
import { ParametricListsService } from 'src/app/infraestructure/services/parametric-lists/parametric-lists.service';
import { ProgrammerApiService } from 'src/app/infraestructure/services/programmer/programmer-api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-gestion-solicitud-transporte',
  templateUrl: './gestion-solicitud-transporte.component.html',
  styleUrls: ['./gestion-solicitud-transporte.component.scss']
})
export class GestionSolicitudTransporteComponent implements OnInit {

  @Output() closedModal = new EventEmitter<any>();
  @Input() solicitudID: number = 0;

  $parametricList: ParametersDTO = new ParametersDTO();
  private $topSubcription = new Subject<void>();
  user$: Observable<UserLogin>;

  rolId: number = 0;
  userId: number = 0;
  tipoVehiculo: number = 0;
  guardar: number = 0;
  habilitarGuardar: boolean = false;
  reloadTableVehicles: number = 0;
  
  constructor(private _listSrv: ParametricListsService,
              private programmerApiSrv: ProgrammerApiService,
              private store: Store<AppState>,) { 
                this.user$ = this.store.select(state => state.user);
                this.user$.subscribe(user => {
                  this.rolId = user.rolId;
                  this.userId = user.id;
                });
               }
  
  ngOnInit(): void {
    this._listSrv.getDataLists('TIP_TIPO_VEHICULO')
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code == 200) {
          this.$parametricList.typeTypeVehicle = res.data;
          this.tipoVehiculo = this.$parametricList.typeTypeVehicle[0].idParametroDetalle;
        }
      });
  }

  saveVehicleSub() {
    this.guardar += 1;
  }

  onSaveVehicle(dataVehiculo: CambiarEstadoVehiculoI) {

    const DATA_VEHICULO: CambiarEstadoVehiculoI = {
      vehiculoId: dataVehiculo.vehiculoId,
      conductorId: dataVehiculo.conductorId,
      solicitudId: this.solicitudID,
      usuarioId: this.userId,
      rolId: this.rolId,
      vcCodigoInterno: "TIP_ESTADO_VEHICULO_ENSERVICIO",
      accion: "ENVIAR_SIGUIENTE_ESTADO",
      bEsVehiculoInterno: dataVehiculo.bEsVehiculoInterno,
      datos: {}
    }
    
    this.programmerApiSrv.postCambiarEstadoVehiculo(DATA_VEHICULO)
    .pipe(takeUntil(this.$topSubcription))
    .subscribe(res => {
      if (res.code === 200) {
        this.onSwal(true, `El vehículo y conductor han sido asignados de manera exitosa a la solicitud #${res.data.id}`, 'Vehículo asignado')
        this.closedModal.emit({'close': true, 'idSolicitud': res.data.id});
      } else {
        const messages = res.errors ? res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n') : res.message;
          
        this.onSwal(false, messages);
      }
    });
  }

  liberarVehiculoInterno(data: any) {

    const DATA_VEHICULO: CambiarEstadoVehiculoI = {
      vehiculoId: data.vehiculoId,
      conductorId: data.conductorId,
      solicitudId: data.solicitudId,
      usuarioId: this.userId,
      rolId: this.rolId,
      vcCodigoInterno: "TIP_ESTADO_VEHICULO_DISPONIBLE",
      bEsVehiculoInterno: true,
      datos: {}
    }    
    
    this.programmerApiSrv.postCambiarEstadoVehiculo(DATA_VEHICULO)
    .pipe(takeUntil(this.$topSubcription))
    .subscribe(res => {
      if (res.code === 200) {
        this.onSwal(true, `El vehículo y conductor han sido liberados de manera exitosa de la solicitud #${res.data.id}`, 'Vehículo liberado')
        this.reloadTableVehicles += 1;
      } else {
        const messages = res.errors ? res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n') : res.message;
          
        this.onSwal(false, messages);
      }
    });
  }

  onSaveVehicleSub(data: GuardarVehiculoSubcontratadoDTO) {
    this.programmerApiSrv.postRegistrarVehiculoSubContratado(data)
    .pipe(takeUntil(this.$topSubcription))
    .subscribe(res => {
      if (res.code === 200) {
        let dataVehiculoSub = {} as CambiarEstadoVehiculoI;
        dataVehiculoSub.vehiculoId = res.data.vehiculo.id;
        dataVehiculoSub.conductorId = res.data.conductor.id;
        dataVehiculoSub.bEsVehiculoInterno = false;
        
        this.onSaveVehicle(dataVehiculoSub);
      } else {
        const messages = res.errors ? res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n') : res.message;
          
        this.onSwal(false, messages);
      }
    })
  }

  onSwal(type: boolean, messages: string, title?: string) {
    if (!type) {
      Swal.fire({
        title: 'Errores',
        icon: 'error',
        html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
        showConfirmButton: true,
        confirmButtonColor: "#004884",
        confirmButtonText: "ACEPTAR",
      });
    } else {
      Swal.fire({
        position: "center",
        icon: "success",
        title: `${title}`,
        text: `${messages}`,
        showConfirmButton: true,
        confirmButtonColor: "#004884",
        confirmButtonText: "ACEPTAR",
      });
    }
  }

  onCancel() {
    this.closedModal.emit({'close': true});
  }
}
